import { Accordion } from "@made-people/blueprint-accordion";
import type { FaqItem } from "./parse-faq-items";

export const FaqQnaItems = ({ items }: { items: FaqItem[] }) => {
  return (
    <Accordion
      layout={{ spacing: { applySpacing: "false" } }}
      items={items.map((item) => ({
        content: {
          value: item.question,
          trigger: (
            <span className="max-lg:text-heading-sm max-lg:font-medium">
              {item.question}
            </span>
          ),
          content: item.answer,
        },
        radixAccordionItemSettings: {
          item: {
            className:
              "group overflow-hidden border-t border-gray-200 last:border-b py-2 lg:py-4",
          },
        },
      }))}
    />
  );
};
